import React from 'react'
import { useSelector } from 'react-redux'
import TopPerformanceV1 from './TopPerformanceV1'
import TopPerformanceV2 from './TopPerformanceV2'
import { TOP_PERFORMANCE_VARIANTS } from '../../constants/uiConfig'

const TopPerformance = () => {
  const { general } = useSelector(state => state.uiConfig)
  const topPerformanceConfig = general?.topPerformanceSectionVariant || {}
  const variantFromConfig = typeof topPerformanceConfig === 'object' && topPerformanceConfig.variant
    ? topPerformanceConfig.variant
    : topPerformanceConfig

  if (variantFromConfig === TOP_PERFORMANCE_VARIANTS.V2) {
    return <TopPerformanceV2 />
  }

  // default fallback to V1 to maintain backward compatibility
  return <TopPerformanceV1 />
}

export default TopPerformance
